import {   NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProfileRoutingModule } from './profile-routing.module';
import { ProfileComponent } from './profile.component';
import { FeaturesCommonModule } from 'src/app/features-common/features-common.module';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { ProfileLogsComponent } from './profile-logs/profile-logs.component';
import { AgGridModule } from 'ag-grid-angular';
import { PasswordUpdateComponent } from './edit-profile/password-update/password-update.component';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { ProfileService } from './profile.service';
import { ResetPasswordComponent } from './edit-profile/reset-password/reset-password.component';


@NgModule({
  declarations: [ProfileComponent, EditProfileComponent, ProfileLogsComponent, ResetPasswordComponent,PasswordUpdateComponent],
  imports: [
    FeaturesCommonModule,
    AgGridModule.withComponents([]),
    ProfileRoutingModule,
    MatPasswordStrengthModule,
    
  ],
  exports: [],
  providers: [ProfileService]
 
})
export class ProfileModule { 
}
